import React from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { Link } from 'react-router-dom';

export default function UsersTable({ users }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
      }}
    >
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((row) => {
              return (
                <TableRow hover tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    const isId = column.id === 'name';
                    return (
                      <TableCell
                        key={column.id}
                        component={isId && Link}
                        to={isId && '/registery'}
                        align={column.align}
                      >
                        {column.format ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

const columns = [
  { id: 'name', label: 'نام', minWidth: 170 },
  { id: 'role', label: 'نقش', minWidth: 100 },
  { id: 'emailAddress', label: 'آدرس ایمیل', minWidth: 100 },
  { id: 'phoneNumber', label: 'شماره تلفن', minWidth: 120 },
  {
    id: 'createdAt',
    label: 'اضافه‌شده در',
    minWidth: 120,
    format: (value) => new Intl.DateTimeFormat('fa-IR').format(new Date(value)),
  },
];
